import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Typography,
  styled,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { apiErrorMessage } from "../../helper/apiError";
import Crossicon from "../../Icon/Crossicon";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { FontFamily } from "../theme/fontFamily";
import { ThemeColor } from "../theme/color";
import { Formik, Form } from "formik";
import CustomButton from "../button/button";
import dayjs from "dayjs";
import * as Yup from "yup";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../select field/OutlinedSelectField";
import {
  AddPaymentDetailsAfterVisaApprovedService,
  UpdateStudentTransactionService,
  bulkUpdateTransactionReceivedFromUniversityNotesAPI,
  calcualteAgentCommissionService,
  getDefaultCommissionDetailsService,
  postFilterStdApproveorNotAPI,
} from "../../Redux/service/Application";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import OnlyDatePicker from "../datepicker/MyDatepicker";
import {
  GetAgentTransactionListAction,
  GetStudentAction,
  GetUnsettledListAction,
} from "../../Redux/action/ApplicationAction";
import Previews from "../dropzone/Mydropzone";
import OutlinedInputField from "../inputfiled/OutlinedInput";
import {
  validationCommisionSchema,
  validationTransactionSchema,
  validationUniversityAmountSchema,
} from "./ValidationConstant";
import OutlinedTextAreaField from "../inputfiled/OutlinedTextedArea";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileManagerPickerModal from "../../page/foldermanagement/FileManagerPickerModal.component";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "80%", md: "450px" },
  bgcolor: "#FFFFFF",
  borderRadius: "16px",
  boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15)",
  border: "none",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const FilterExcelUniversity = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [VisaStatus, setVisaStatus] = useState("");
  const [commResdata, setCommResdata] = useState(null);

  const formikRef = useRef(null);

  const [loading, setLoading] = useState(true);

  const [jsonData, setJsonData] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFileUrl, setSelectedFileUrl] = useState("");
  const [filePickerOpen, setFilePickerOpen] = useState(false);

  const handleExportForNotApproved = async (notFoundData) => {
    console.log(notFoundData);

    const columns = [
      { header: "First Name", key: "studentFirstName" },
      { header: "Last Name", key: "studentLastName" },
      { header: "Date of Birth", key: "dateOfBirth" },
      { header: "Student ID", key: "universityId" },
      { header: "Program", key: "program.program" },
      { header: "Degree", key: "degreeType.name" },
      {
        header: "Semester",
        key: "intake",
      },
      {
        header: "Payment",
        key: "currentTransactionNumber",
      },
      { header: "University Amount", key: "receivedFromUniversity" },
      // { header: "Eligible", key:"data.commissionStatus" },
      // { header: "Reason", key: "data.commissionStatusNotes" },
    ];

    const transformedData = notFoundData.map((item) => {
      const row = {};
      columns.forEach((col) => {
        row[col.header] =
          col.key.split(".").reduce((o, k) => (o || {})[k], item) || ""; // Handle nested keys
      });
      return row;
    });

    // Create a worksheet for the first dataset
    const worksheet = XLSX.utils.json_to_sheet(transformedData);

    // Apply background styling to headers
    const headers = columns.map((col) => col.header);
    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index }); // First row (0), column index
      if (!worksheet[cellAddress]) worksheet[cellAddress] = {}; // Ensure the cell exists
      worksheet[cellAddress].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "FFCCFFCC" }, // Light green background color
        },
        font: {
          bold: true,
          color: { rgb: "FF000000" }, // Black text
        },
      };
    });

    // Create a workbook and append the sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CombinedData");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(dataBlob, `NotFoundTransaction.xlsx`);
  };

  const handleExportForApproved = async (approved) => {
    console.log(approved)
    let studentApproved = approved.map((data) => ({
      studentId: data._id,
      currentTransactionNumber: data.requestFilter.currentTransactionNumber,
      receivedFromUniversity: data.requestFilter.receivedFromUniversity,
      bonusFromUniversity: data.requestFilter?.bonusFromUniversity
        ? data.requestFilter?.bonusFromUniversity
        : "",
      notes: data.requestFilter?.notes ? data.requestFilter?.notes : "",
      commissionStatus: data.requestFilter?.commissionStatus,
      commissionStatusNotes: data.requestFilter?.commissionStatusNotes,
    }));

    console.log(studentApproved);

    await bulkUpdateTransactionReceivedFromUniversityNotesAPI(studentApproved)
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
          dispatch(showSnackbar(res.data.message, "success"));

          dispatch(GetUnsettledListAction(false));

          onClose();

          // if (res.data?.students !== null) {
          //   handleExportForApproved(res.data?.students);
          // }

          // if (res.data?.notFoundData !== null) {
          //   handleExportForNotApproved(res.data?.notFoundData);
          // }
          // resetForm();
        }
      })
      .catch((e) => {
        dispatch(showSnackbar(apiErrorMessage(e), "error"));
      });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target?.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);
      const formattedData = formatKeys(parsedData);
      console.log(formattedData);
      formikRef.current.setFieldValue("data", formattedData);
      setJsonData(formattedData);
    };
    reader.readAsBinaryString(file);
  };

  const handleServerFileSelect = async (file) => {
    setSelectedFileName(file.name);
    setSelectedFileUrl(file.url);
    setLoading(true);
    try {
      const response = await fetch(file.url);
      if (!response.ok) throw new Error("Download failed");
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);
      const formattedData = formatKeys(parsedData);
      console.log(formattedData);
      formikRef.current.setFieldValue("data", formattedData);
      setJsonData(formattedData);
    } catch (err) {
      console.error("Failed to fetch CRM file", err);
      dispatch(showSnackbar("Failed to fetch CRM file", "error"));
    } finally {
      setLoading(false);
    }
  };

  // Map of old keys to new keys
  const keyMapping = {
    "CAE ID": "uniqueCaeId",
    "First Name": "studentFirstName",
    "Last Name": "studentLastName",
    Semester: "intake",
    degree: "degreeType",
    Payment: "currentTransactionNumber",
    "University Amount": "receivedFromUniversity",
    "Date of Birth": "dateOfBirth",
    Bonus: "bonusFromUniversity",
    "Student ID": "universityId",
    Program: "program",
    Degree: "degreeType",
    "Commission Status Notes": "commissionStatusNotes",
    "Commission Status": "commissionStatus",
    Notes: "notes",
  };

  // const formatKeys = (data) => {
  //   return data.map((row) => {
  //     const formattedRow = {};
  //     for (const key in row) {
  //       // Format key dynamically
  //       const formattedKey = key
  //         .replace(/\s+/g, "") // Remove spaces
  //         .replace(/^[A-Z]/, (c) => c.toLowerCase()); // Lowercase the first letter

  //       formattedRow[formattedKey] = row[key];
  //     }
  //     return formattedRow;
  //   });
  // };

  // Function to format keys in data
  const formatKeys = (data) => {
    return data.map((row) => {
      const formattedRow = {};
      for (const key in row) {
        const newKey = keyMapping[key] || key; // Replace key if it exists in keyMapping
        formattedRow[newKey] = row[key];
      }
      return formattedRow;
    });
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setCommResdata(null);
        setLoading(true);
        setSelectedFileName("");
        setSelectedFileUrl("");
        onClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            bgcolor: ThemeColor.PURPLE,
            color: "#FFFFFF",
          }}
        >
          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W600}
            fontSize={fontSize.h3.medium}
            color="#FFFFFF"
          >
            Import University Transaction
          </Typography>
          <IconButton
            onClick={() => {
              setCommResdata(null);
              setLoading(true);
              setSelectedFileName("");
              setSelectedFileUrl("");
              onClose();
            }}
            size="small"
            sx={{
              color: "#FFFFFF",
              bgcolor: "rgba(255, 255, 255, 0.15)",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.3)" },
            }}
          >
            <Crossicon width={"16"} height={"16"} fill="#FFF" />
          </IconButton>
        </Box>

        {/* Form Body */}
        <Box sx={{ p: 3, backgroundColor: "#FFFFFF" }}>
          <Formik
            innerRef={formikRef}
            initialValues={{ data: jsonData }}
            onSubmit={async (values, { resetForm }) => {
              await postFilterStdApproveorNotAPI(values)
                .then((res) => {
                  if (res.status === 200) {
                    if (res.data?.students !== null) {
                      handleExportForApproved(res.data?.students);
                    }
                    if (res.data?.notFoundData !== null) {
                      handleExportForNotApproved(res.data?.notFoundData);
                    }
                    resetForm();
                    setSelectedFileName("");
                    setSelectedFileUrl("");
                  }
                })
                .catch((e) => {
                  dispatch(showSnackbar(e.response?.data?.message || "Upload failed", "error"));
                });
            }}
            validationSchema={Yup.object().shape({
              data: Yup.array().min(1, "Please choose a valid excel file first.").required("The data array is required."),
            })}
          >
            {({
              values,
              errors,
              handleBlur,
              handleChange,
              touched,
              handleSubmit,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2.5}>
                  <Grid item xs={12}>
                    <FormGroup>
                      <div className="w-100 d-flex flex-column justify-content-center">
                        <Box
                          component="label"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px dashed #CBD5E1",
                            borderRadius: "12px",
                            padding: "30px 20px",
                            backgroundColor: "#F8FAFC",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              borderColor: ThemeColor.PURPLE,
                              backgroundColor: "#F1F5F9",
                            },
                          }}
                        >
                          <CloudUploadIcon sx={{ fontSize: 40, color: "#94A3B8", mb: 1.5 }} />
                          <Typography
                            fontFamily={FontFamily.Poppins}
                            fontWeight={fontWeight.W500}
                            fontSize="0.875rem"
                            color="#475569"
                          >
                            Click to select file (.xlsx, .xls)
                          </Typography>
                          <Typography
                            fontFamily={FontFamily.Poppins}
                            fontSize="0.75rem"
                            color="#94A3B8"
                            mt={0.5}
                            sx={{ wordBreak: "break-all", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}
                          >
                            {selectedFileName ? `Selected: ${selectedFileName}` : "Browse files on your device"}
                            {selectedFileUrl && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  window.open(selectedFileUrl, "_blank", "noopener noreferrer");
                                }}
                                sx={{ color: ThemeColor.PURPLE, p: 0.5 }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Typography>
                          <input
                            type="file"
                            accept=".xlsx, .xls"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              if (e.target.files && e.target.files[0]) {
                                setSelectedFileName(e.target.files[0].name);
                                setSelectedFileUrl(""); // Local files do not have a CRM URL
                              }
                              handleFileUpload(e);
                            }}
                          />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 1, alignItems: "center" }}>
                          <Typography sx={{ color: "#94A3B8", fontSize: "0.8rem", mx: 1 }}>OR</Typography>
                        </Box>

                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => setFilePickerOpen(true)}
                          sx={{
                            borderRadius: "10px",
                            textTransform: "none",
                            color: ThemeColor.PURPLE,
                            borderColor: ThemeColor.PURPLE,
                            fontFamily: FontFamily.Poppins,
                            "&:hover": { borderColor: ThemeColor.PURPLE, backgroundColor: "#f9fafb" },
                          }}
                        >
                          Select from CRM File Manager
                        </Button>
                        <FileManagerPickerModal
                          open={filePickerOpen}
                          handleClose={() => setFilePickerOpen(false)}
                          onSelectFile={handleServerFileSelect}
                        />
                        {errors && errors?.data && (
                          <Typography
                            align="left"
                            color={ThemeColor.RED}
                            fontSize="0.8rem"
                            fontFamily={FontFamily.Lato}
                            fontWeight={fontWeight.W500}
                            mt={1}
                          >
                            {errors?.data}
                          </Typography>
                        )}
                      </div>
                    </FormGroup>
                  </Grid>

                  <Grid item xs={12} display="flex" justifyContent="center" mt={1}>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                    >
                      Save
                    </CustomButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Modal>
  );
};
